export default __webpack_public_path__ + "static/media/20.93f653c5.png";